import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Switch,
  TextField,
  Tooltip,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import jwtDecode from "jwt-decode";
import DiscountGrid from "./DiscountGrid";
import OAuthService from "src/app/auth/services/oAuthService";
import DialogBox from "../utilities/DialogBox";

const getServerSideDatasource = (server) => {
  return {
    getRows: (params) => {
      console.log("[Datasource] - rows requested by grid: ", params.request);
      // get data for request from our fake server
      var response = server.getData(params.request);
      // simulating real server call with a 500ms delay
      setTimeout(function () {
        if (response.success) {
          // supply rows for requested block to grid
          params.success({
            rowData: response.rows,
            rowCount: response.lastRow,
          });
        } else {
          params.fail();
        }
      }, 500);
    },
  };
};
const CollapsibleFilters = ({ children, label = "Filters" }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), {
    noSsr: true,
  });
  const [open, setOpen] = useState(false);

  if (!isMobile) return <>{children}</>;

  return (
    <Box sx={{ width: "100%" }}>
      <Button
        fullWidth
        size="small"
        variant="outlined"
        color="secondary"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        startIcon={<FuseSvgIcon>heroicons-outline:filter</FuseSvgIcon>}
        endIcon={
          <FuseSvgIcon>
            {open
              ? "heroicons-outline:chevron-up"
              : "heroicons-outline:chevron-down"}
          </FuseSvgIcon>
        }
      >
        {label}
      </Button>
      <Collapse in={open}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            pt: 1,
            pb: 1,
          }}
        >
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};
  const FilterField = ({ children }) => (
    <Box
      sx={{
        display: { xs: "flex", md: "contents" },
        flexDirection: { xs: "column" },
        width: { xs: "100%", md: "auto" },
        gap: { xs: 0.25 },
      }}
    >
      {children}
    </Box>
  );
const DiscountMaster = (props) => {
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.discounts}`;
  const [selectedRows, setSelectedRows] = useState([]);
  const [error, setError] = useState("");
  const childRef = useRef();
  const [saveBtnDisable, setSaveBtnDisable] = useState(true);
  const [snackState, setSnackState] = useState(false);
  const [activeOpen, setActiveOpen] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [priRequest, setPriRequest] = useState([]);
  const [autoSizeMode, setAutoSizeMode] = useState(true);
  const [priApprove, setPriApprove] = useState([]);
  const [gridRef, setGridRef] = useState();
  const [updateData, setUpdateData] = useState([]);
  const [deleteDisable, setDeleteDisable] = useState(true);
  const [discountType, setDiscountType] = useState("Customer");
  const [active, setActive] = useState(false);
  const [discountTypeList, setDiscountTypeList] = useState([
    { label: "Partner", value: "Customer" },
    { label: "Vendor", value: "Vendor" },
  ]);
  const [yearOptions, setYearOptions] = useState();
  const [fromYearOptions, setFromYearOptions] = useState();
  const [toYearOptions, setToYearOptions] = useState();
  const [year, setYear] = useState(new Date().getFullYear());
  const [copyYear, setCopyYear] = useState();
  const [fromYear, setFromYear] = useState();
  const [toYear, setToYear] = useState();
  const [saveOpen, setSaveOpen] = useState(false);
  const [copyOpen, setCopyOpen] = useState(false);
  const [productList, setProductList] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [discountStatus, setDiscountStatus] = useState("APPROVED");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [customer, setCustomer] = useState({ value: "ALL", label: "ALL" });
  const [vendor, setVendor] = useState({ value: "ALL", label: "ALL" });
  const [vendorName, setVendorName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [statusOptions, setStatusOptions] = useState([
    { value: "All", label: "All" },
    { label: "New", value: "NEW" },
    { label: "Approved", value: "APPROVED" },
    { label: "Rejected", value: "REJECTED" },
    { label: "Pending For Approval", value: "PENDING_APPROVAL" },
  ]);
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  useEffect(() => {
    if (token?.scope.includes("ROLE_MD")) {
      setDiscountStatus("PENDING_APPROVAL");
    }
  }, []);

  useEffect(() => {
    if (selectedRows.length > 0) {
      setDeleteDisable(false);
    } else {
      setDeleteDisable(true);
    }
  }, [selectedRows]);
  useEffect(() => {
    if (selectedRows.length > 0 && selectedRows[0]?.id) {
      setEditMode(true);
    } else {
      setEditMode(false);
    }
  }, [selectedRows]);

  const getCustomer = async () => {
    const companiesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
    const list = await OAuthService.getList(
      companiesUrl +
        `/search/findByCustomerTypes?customerTypes=REGULAR&sort=id,ase,&size=1000`,
    );
    let companies = list.data?._embedded?.companies;
    companies = companies.map((company) => {
      return {
        value: company.id,
        label: `${company?.id}-${company?.shortKey}-${company?.countryName}`,
      };
    });
    companies = [{ value: "ALL", label: "ALL" }, ...companies];
    setCustomerOptions(companies);
  };
  const getVendorsList = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
    try {
      const list = await OAuthService.getList(
        `${url}/search/findByActive?active=true`,
      );
      let factoryVendorData = list.data?._embedded?.factoryVendors;
      factoryVendorData = factoryVendorData.map((vendor) => {
        return {
          label: vendor.shortKey,
          value: vendor.id,
        };
      });
      factoryVendorData = [
        { value: "ALL", label: "ALL" },
        ...factoryVendorData,
      ];
      setVendorOptions(factoryVendorData);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };
  useEffect(() => {
    getCustomer();
    getVendorsList();
  }, []);
  useEffect(() => {
    const arg = "ROLE_";
    const roles = token?.scope.filter((value) => {
      return value.startsWith(arg);
    });
    const users = async () => {
      try {
        await Promise.all(
          roles.map(async (role) => {
            const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.user}/privilegesByRole?roleName=${role}`;
            try {
              const checkRole = await OAuthService.getList(userUrl);
              checkRole.data?.result?.filter((role) => {
                if (role.id === "PRIVILEGE_REQDISC") {
                  priRequest.push(role);
                  setPriRequest(priRequest);
                }
                if (role.id === "PRIVILEGE_APPDISC") {
                  priApprove.push(role);
                  setPriApprove(priRequest);
                }
                return role;
              });
            } catch (error) {}
          }),
        );
      } catch {}
    };
    users();
  }, []);

  useEffect(() => {
    const cyear = new Date().getFullYear();
    let years = Array.from(new Array(20), (val, index) => {
      return { label: cyear - index, value: cyear - index };
    });
    years = [{ label: cyear + 1, value: cyear + 1 }, ...years];
    setYear(cyear);
    setYearOptions(years);
  }, []);
  useEffect(() => {
    const currentYear = new Date().getFullYear();

    const fromYears = Array.from(
      { length: currentYear - 2024 + 1 },
      (_, index) => {
        const year = 2024 + index;
        return { label: year, value: year };
      },
    );

    const toYears = Array.from({ length: 6 }, (_, index) => {
      const year = currentYear + index;
      return { label: year, value: year };
    });

    setFromYearOptions(fromYears);
    setToYearOptions(toYears);
  }, []);

  const onTypeDropdownChange = useCallback(
    (data) => {
      setDiscountType(data.value);
      loadDiscountColumns(data.value);
    },
    [year, discountStatus],
  );

  const onYearDropdownChange = useCallback(
    (data) => {
      setYear(data.value);
    },
    [discountType, discountStatus],
  );

  const onStatusDropdownChange = useCallback(
    (data) => {
      setDiscountStatus(data.value);
    },
    [discountType, year],
  );
 const onCustomerDropdownChange = useCallback((data) => {
  setCustomer(data);
  if (data.label !== "ALL") {
    setCustomerName(data.label);
  }
}, []);

const onVendorDropdownChange = useCallback((data) => {
  setVendor(data);
  if (data.label !== "ALL") {
    setVendorName(data.label);
  }
}, []);
  const onFromYearDropdownChange = useCallback((data, action) => {
    setFromYear(action.action === "clear" ? "" : data.value);
  }, []);
  const onToYearDropdownChange = useCallback((data, action) => {
    setToYear(action.action === "clear" ? "" : data.value);
  }, []);
  const discountListDropdown =()=> {
  const discount =
    updateData.length > 0 &&
    selectedRows.length > 0 &&
    updateData.filter((data) => {
      if (data.id === selectedRows[0]?.id) {
        return data;
      }
    });

  const submitApproval =
    (priRequest && priRequest.length > 0) ||
    token?.scope.includes("PRIVILEGE_REQDISC");
  const approveReject =
    (priApprove && priApprove.length > 0) ||
    token?.scope.includes("PRIVILEGE_APPDISC");



  return (
    <>
     <CollapsibleFilters>
      <FilterField>
        <label className="pt-6">Customer</label>
        <Select
          name="customer"
          value={customer}
          onChange={onCustomerDropdownChange}
          className="w-full md:w-[140px]"
          options={customerOptions}
          styles={customStyles("", "", "0px")}
        />
      </FilterField>

      <FilterField>
        <label className="pt-6">Vendor</label>
        <Select
          name="vendor"
          value={vendor}
          onChange={onVendorDropdownChange}
          className="w-full md:w-[140px]"
          options={vendorOptions}
          styles={customStyles("", "", "0px")}
        />
      </FilterField>

      <FilterField>
        <label className="pt-6">Type</label>
        <Select
          name="budgetType"
          value={
            discountTypeList &&
            discountType &&
            discountTypeList.filter((obj) => discountType.includes(obj.value))
          }
          onChange={onTypeDropdownChange}
          className="w-full md:w-[140px]"
          options={discountTypeList}
          styles={customStyles("", "", "0px")}
        />
      </FilterField>

      <FilterField>
        <label className="pt-6">Year</label>
        <Select
          name="year"
          value={
            yearOptions &&
            year &&
            yearOptions.filter((obj) => year === obj.value)
          }
          onChange={onYearDropdownChange}
          className="w-full md:w-[110px]"
          options={yearOptions}
          styles={customStyles("", "", "0px")}
        />
      </FilterField>

      <FilterField>
        <label className="pt-6">Status</label>
        <Select
          name="year"
          value={
            statusOptions &&
            discountStatus &&
            statusOptions.filter((obj) => discountStatus === obj.value)
          }
          onChange={onStatusDropdownChange}
          className="w-full md:w-[110px]"
          options={statusOptions}
          styles={customStyles("", "", "0px")}
        />
      </FilterField>
     </CollapsibleFilters>

      {(selectedRows.length > 0 || discount.length > 0) && (
        <Button
          variant="contained"
          color="secondary"
          disabled={saveBtnDisable}
          onClick={handleSaveOpen}
        >
          <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
        </Button>
      )}
      {discountType === "Vendor"
        ? selectedRows.length > 0 &&
          !token?.scope.includes("ROLE_MD") &&
          selectedRows.every((row) => row?.id) &&
          selectedRows[0]?.approvalStatus === "NEW" &&
          submitApproval && (
            <Tooltip title="Submit For Approval">
              <Button
                variant="contained"
                color="secondary"
                disabled={selectedRows[0]?.id ? false : true}
                onClick={handleRequestApprovalDiscount}
              >
                <i className="material-icons">thumb_up</i>
              </Button>
            </Tooltip>
          )
        : selectedRows.length > 0 &&
          !token?.scope.includes("ROLE_MD") &&
          selectedRows.every((row) => row?.id) &&
          selectedRows[0]?.approvalStatus === "NEW" &&
          submitApproval && (
            <Tooltip title="Submit For Approval">
              <Button
                variant="contained"
                color="secondary"
                disabled={selectedRows[0]?.id ? false : true}
                onClick={handleRequestApprovalDiscount}
              >
                <i className="material-icons">thumb_up</i>
              </Button>
            </Tooltip>
          )}
      {discountType === "Vendor"
        ? selectedRows.length > 0 &&
          selectedRows[0]?.id &&
          selectedRows.every((row) => row?.id) &&
          approveReject &&
          selectedRows[0]?.approvalStatus === "PENDING_APPROVAL" && (
            <Tooltip title="Approved">
              <Button
                variant="contained"
                color="success"
                onClick={handleSubmitApprovalDiscount}
              >
                <i className="material-icons">done</i>
              </Button>
            </Tooltip>
          )
        : selectedRows.length > 0 &&
          selectedRows[0]?.id &&
          selectedRows.every((row) => row?.id) &&
          approveReject &&
          selectedRows[0]?.approvalStatus === "PENDING_APPROVAL" && (
            <Tooltip title="Approved">
              <Button
                variant="contained"
                color="success"
                onClick={handleSubmitApprovalDiscount}
              >
                <i className="material-icons">done</i>
              </Button>
            </Tooltip>
          )}
      {discountType === "Vendor"
        ? selectedRows.length > 0 &&
          selectedRows[0]?.id &&
          selectedRows.every((row) => row?.id) &&
          approveReject &&
          selectedRows[0]?.approvalStatus === "PENDING_APPROVAL" && (
            <Tooltip title="Reject">
              <Button
                variant="contained"
                color="error"
                onClick={handleSubmitDeclineDiscount}
              >
                <i className="material-icons">cancel</i>
              </Button>
            </Tooltip>
          )
        : selectedRows.length > 0 &&
          selectedRows[0]?.id &&
          selectedRows.every((row) => row?.id) &&
          approveReject &&
          selectedRows[0]?.approvalStatus === "PENDING_APPROVAL" && (
            <Tooltip title="Reject">
              <Button
                variant="contained"
                color="error"
                onClick={handleSubmitDeclineDiscount}
              >
                <i className="material-icons">cancel</i>
              </Button>
            </Tooltip>
          )}
      {handleSaveDiscount && (
        <Dialog
          open={saveOpen}
          onClose={handleSaveClose}
          fullWidth
          maxWidth="xs"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent sx={{ p: 3 }}>
            <DialogContentText id="alert-dialog-description" sx={{ mb: 2 }}>
              Are you sure you want to save discount?
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2, flexWrap: "wrap", gap: 1 }}>
            {!editMode && (
              <Button
                variant="contained"
                color="secondary"
                onClick={handleSaveAndApproveDiscount}
              >
                Save & Send for Approval
              </Button>
            )}
            <Button
              onClick={handleSaveDiscount}
              variant="contained"
              color="secondary"
            >
              Save
            </Button>
            <Button
              onClick={handleSaveClose}
              variant="outlined"
              color="secondary"
              autoFocus
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <Button
        onClick={toggleAutoSize}
        variant="contained"
        color="error"
        sx={{ height: 30, minHeight: 30, maxHeight: 30, fontSize: 11 }}
      >
        {autoSizeMode ? "Auto-Size Columns" : "Reset Columns"}
      </Button>
      {(token?.scope?.includes("ROLE_MD") ||
        token?.scope?.includes("ROLE_ADMIN") ||
        token?.scope?.includes("ROLE_SOPDIR")) && (
        <Tooltip title="Copy Discount">
          <Button
            onClick={() => setCopyOpen(true)}
            variant="contained"
            color="secondary"
          >
            <FuseSvgIcon>material-solid:copy_all</FuseSvgIcon>
          </Button>
        </Tooltip>
      )}
      {handleCopyDiscount && (
        <Dialog
          open={copyOpen}
          onClose={handleCopyClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xs"
          sx={{
            "& .MuiPaper-root": {
              maxHeight: { xs: "70vh", sm: "30vh" },
              height: { xs: "auto", sm: "30vh" },
              borderRadius: "16px",
              padding: "1rem",
            },
          }}
        >
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontSize: "1rem",
                fontWeight: 500,
                mb: 2,
                color: "text.primary",
              }}
            >
              Please Choose the years to copy discount
            </DialogContentText>
            <div className="mb-6">
              <label className="block mb-2 font-medium text-gray-700">
                From Year
              </label>
              <Select
                name="fromYear"
                value={
                  (fromYearOptions &&
                    fromYearOptions.filter((obj) => fromYear === obj.value)) ||
                  null
                }
                onChange={onFromYearDropdownChange}
                className="w-full"
                options={fromYearOptions}
                styles={customStyles("", "", "0px")}
                placeholder="Select from year..."
                isClearable
              />
            </div>
            <div>
              <label className="block mb-2 font-medium text-gray-700">
                To Year
              </label>
              <Select
                name="toYear"
                value={
                  (toYearOptions &&
                    toYearOptions.filter((obj) => toYear === obj.value)) ||
                  null
                }
                onChange={onToYearDropdownChange}
                className="w-full"
                options={toYearOptions}
                styles={customStyles("", "", "0px")}
                placeholder="Select to year..."
                isClearable
              />
            </div>
          </DialogContent>
          <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleCopyDiscount}
              disabled={!(fromYear && toYear)}
            >
              Copy
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleCopyClose}
              autoFocus
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}

  const handleSaveClose = () => {
    setSaveOpen(false);
  };
  const handleSaveOpen = () => {
    if (token?.scope?.includes("ROLE_MD")) {
      handleSaveDiscount();
    } else {
      setSaveOpen(true);
    }
  };
  const handleCopyClose = () => {
    setCopyOpen(false);
  };

  const handleSaveDiscount = () => {
    const childelement = childRef.current;
    childelement.handleSaveDiscount();
  };

  const handleSaveAndApproveDiscount = () => {
    const childelement = childRef.current;
    childelement.handleSaveAndApproveDiscount();
  };
  const handleCopyDiscount = () => {
    const childelement = childRef.current;
    childelement.handleCopyDiscount();
  };
  const onResetColumnState = () => {
    const childelement = childRef.current;
    childelement.onResetColumnState();
  };
  const handleSubmitDeclineDiscount = () => {
    const childelement = childRef.current;
    childelement.handleSubmitDeclineDiscount();
  };
  const handleSubmitApprovalDiscount = () => {
    const childelement = childRef.current;
    childelement.handleSubmitApprovalDiscount();
  };
  const handleRequestApprovalDiscount = () => {
    const childelement = childRef.current;
    childelement.handleRequestApprovalDiscount();
  };
  const onBtExport = () => {
    const childelement = childRef.current;
    childelement.onBtExport();
  };
  const loadDiscountColumns = (value) => {
    const childelement = childRef.current;
    childelement.loadDiscountColumns(value);
  };

  const handleSuccessMsg = (msg) => {
    if (msg) {
      setSuccessMsg(msg);
      setSnackState(true);
    } else {
      setSnackState(false);
    }
  };

  const handleSelectedRows = (selected) => {
    setSelectedRows(selected ? selected : []);
  };

  const handleUpdateData = (updated) => {
    setUpdateData(updated ? updated : []);
  };
  const handleSaveBtnDisable = (state) => {
    setSaveBtnDisable(state === false ? false : true);
  };
  const handleError = (eror) => {
    setError(eror ? eror : "");
  };
  const handleGridRef = (ref) => {
    setGridRef(ref);
  };

  const toggleAutoSize = () => {
    const childelement = childRef.current;
    childelement.toggleAutoSize(autoSizeMode);
    setAutoSizeMode(!autoSizeMode);
  };

  useEffect(() => {
    handleSuccessMsg();
    handleSelectedRows();
    handleUpdateData();
    handleSaveBtnDisable();
    handleError();
    handleGridRef();
  }, []);

  return (
    <>
      <ListPageHeader
        componentName="Discount Master"
        onBtExport={onBtExport}
        // handleAddButton={handleAddButton}
        pageName="Discount Master List"
        headerInputFields={discountListDropdown()}
        error={error}
        pageSize={20}
        gridRef={gridRef}
        deleteDisable={deleteDisable}
        successMsg={successMsg}
        onResetColumnState={onResetColumnState}
        snackState={snackState}
      />
      <div className="h-full">
        <DiscountGrid
          ref={childRef}
          discountStatus={discountStatus}
          discountType={discountType}
          customerId={customer.value === "ALL" ? "" : customer.value}
          vendorId={vendor.value === "ALL" ? "" : vendor.value}
          customerName={customerName}
          vendorName={vendorName}
          year={year}
          fromYear={fromYear}
          toYear={toYear}
          handleSaveDiscount={handleSaveDiscount}
          handleCopyDiscount={handleCopyDiscount}
          handleSaveAndApproveDiscount={handleSaveAndApproveDiscount}
          onResetColumnState={onResetColumnState}
          handleSubmitDeclineDiscount={handleSubmitDeclineDiscount}
          handleSubmitApprovalDiscount={handleSubmitApprovalDiscount}
          handleRequestApprovalDiscount={handleRequestApprovalDiscount}
          onBtExport={onBtExport}
          loadDiscountColumns={loadDiscountColumns}
          successMsg={handleSuccessMsg}
          updateData={handleUpdateData}
          selectedRows={handleSelectedRows}
          saveBtnDisable={handleSaveBtnDisable}
          handleSaveClose={handleSaveClose}
          handleCopyClose={handleCopyClose}
          error={handleError}
          gridRef={handleGridRef}
        />
      </div>
    </>
  );
};

export default DiscountMaster;
